export default {
  countries: 'البلاد',
  country: 'البلد',
  add: 'إضافة بلد',
  update: 'تعديل البلد',
  details: 'تفاصيل البلد'
}
